import React from "react";
import "./footer.css";


//import { Container, Row, Col } from "react-bootstrap";

const Footer = ({isScrollable}) => {
    return (
        <section 
            className={`section5 ${isScrollable ? "scroll-snap-footer" : ""}`} id="section5">
            <div class="container content-footer">
                <div class="footer-content">
                    <div class="footer-column">
                        <h3>Global Export</h3>
                        <p>Somos expertos en comercio internacional dedicados a impulsar el crecimiento global de empresas como la tuya.</p>
                    </div>

                    <div class="footer-column">
                        <h3>Enlaces Rápidos</h3>
                        <ul class="footer-links">
                            <li><a href="/">Inicio</a></li>
                            <li><a href="/team">Equipo</a></li>
                            <li><a href="/services">Servicios</a></li>
                            <li><a href="/contact">Contacto</a></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h3>Servicios</h3>
                        <ul class="footer-links">
                            <li><a href="/services">Comercio Exterior</a></li>
                            <li><a href="/services">Marketing Internacional</a></li>
                            <li><a href="/services">Gestión Financiera</a></li>
                            <li><a href="/services">Networking Comercial</a></li>
                            <li><a href="/services">Gestión de Proyectos</a></li>
                            <li><a href="/services">Capitación y Desarrollo</a></li>
                        </ul>
                    </div>

                    <div class="footer-column" >
                        <h3>Contáctanos</h3>
                        <ul class="contact-info">
                            <li><i class="fas fa-phone"></i> +51 924 654 344</li>
                            <li><i class="fas fa-envelope"></i> lopezh.stefani@gmail.com</li>
                        </ul>
                    </div>
                </div>

                <div class="footer-bottom">
                    <p>&copy; 2025 Voila Consulting. Todos los derechos reservados.</p>
                    <p>Pagina desarrollado por: <a className="ing" href="https://davidhurtado.netlify.app" target="_blank" rel="noreferrer">Ing. David Hurtado.</a></p>
                </div>
            </div>
        </section>
    );
};

export default Footer;